import { useCallback } from 'react';

import { Button } from '@simplywallst/ui-core/next';
import DownloadReportSolid from '@simplywallst/ui-core/icons/DownloadReportSolid';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import type { DateRange } from '../../hooks/useDateRangeState';

import { getISODateAtUTC } from '../../utils';

import { useCSVDownload } from '../../hooks';

type Props = DateRange & {
  portfolioId: Portfolio['id'];
  isDisabled?: boolean;
};

export const DownloadCSVButton = ({
  portfolioId,
  start,
  end,
  isDisabled,
}: Props) => {
  const { mutate, status: downloadStatus } = useCSVDownload();

  const handleDownloadCSV = useCallback(() => {
    // Empty string for "since inception" date range
    const startDate = start === null ? '' : getISODateAtUTC(start);
    const endDate = end === null ? '' : getISODateAtUTC(end);

    mutate({
      portfolioId,
      startDate,
      endDate,
    });
  }, [mutate, portfolioId, start, end]);
  return (
    <Button
      variant="outline"
      onClick={handleDownloadCSV}
      isLoading={downloadStatus === 'pending'}
      isDisabled={downloadStatus === 'pending' || isDisabled}
    >
      Download <span className="hidden sm:inline">as CSV </span>
      <DownloadReportSolid />
    </Button>
  );
};
